import { FC, memo } from 'react';
import { TextProps } from 'antd/es/typography/Text';
import { TextEllipsis } from './TextEllipsis';
import styled from 'styled-components';
import { Flex } from 'antd';
import { Tooltip } from './Tooltip';

export interface MultiRowTextEllipsisProps extends Omit<TextProps, 'children'> {
  maxRows?: number;
  children: string;
}

export const MultiRowTextEllipsis: FC<MultiRowTextEllipsisProps> = memo(
  (props) => {
    const { maxRows = 3, children, ...rest } = props;
    const rows = children.split('\n');
    const rowCount = rows.length;
    const isMultiline = rowCount > 1;
    const isOverflow = rowCount > maxRows;

    if (isMultiline) {
      return (
        <Tooltip title={<MultilineWrapper>{children}</MultilineWrapper>}>
          <Flex vertical>
            {rows.slice(0, maxRows).map((row, index) => (
              <TextEllipsis key={index} tooltip={false}>
                {row}
              </TextEllipsis>
            ))}
            {isOverflow && `+${rowCount - maxRows}`}
          </Flex>
        </Tooltip>
      );
    }

    return (
      <TextEllipsis
        ellipsis={{
          tooltip: {
            title: <MultilineWrapper>{children}</MultilineWrapper>,
            overlayStyle: { maxWidth: '100vw' },
          },
        }}
        {...rest}
      >
        {children}
      </TextEllipsis>
    );
  },
);

export const MultilineWrapper = styled.div`
  white-space: pre;
`;
